// 파일 미리보기
export const fileDownload = (response, setPreviewUrl, setShowModal, setContentType) => {
  const contentType = response.headers["content-type"];
  const previewUrl = URL.createObjectURL(
    new Blob([response.data], { type: contentType })
  );
  // window.open(previewUrl, "_blank");
  setPreviewUrl(previewUrl);
  setShowModal(true);
  setContentType(contentType);  
};
